import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "tab__container" }

import { IRouterInfo } from '@/coreDomainsModule/entities/routerInfo';
import { i18n } from '@/i18n';
import { useRoute } from 'vue-router';
import { isEqualRouterInfo } from '../domains/routerInfo';


export default /*@__PURE__*/_defineComponent({
  __name: 'ControlCustomerPageTab',
  props: {
    tabInfoObject: {}
  },
  setup(__props: any) {

const t = i18n.t;

// props
const props = __props;

const route = useRoute();

/**
 * RouterLinkのクラスをチェックする
 * @param info - Path情報
 */
const routerLinkClass = (info: IRouterInfo) =>
  isEqualRouterInfo(route, info) || (info.router === '/customer' && route.path.startsWith('/customer/FR'))
    ? 'tab__item--active'
    : 'tab__item--inactive';

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabInfoObject, (info, index) => {
      return (_openBlock(), _createBlock(_component_RouterLink, {
        key: index,
        class: _normalizeClass(["tab__item", routerLinkClass(info)]),
        to: info.router
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", null, _toDisplayString(_unref(t)(info.label)), 1)
        ], undefined, true),
        _: 2
      }, 1032, ["class", "to"]))
    }), 128))
  ]))
}
}

})